
import { computed, defineComponent, SetupContext, PropType, toRefs, watch, ref } from "vue";
import NativeClient from "@/client/native-client";
import { FridgeDetailsDisplaySettingsListItem } from "@/types/fridgeDetails"
import FridgeDetailsConfirmSettingsDialogItem from "./FridgeDetailsConfirmSettingsDialogItem.vue";

export default defineComponent({
  name: "FridgeDetailsConfirmSettingsDialog",
  components: {
    FridgeDetailsConfirmSettingsDialogItem
  },
  props: {
    /** ダイアログのアクティブ状態 (true: 活性、false: 非活性) */
    isShowDialog: {
      type: Boolean,
      default: false
    },
    /** タイトル */
    displayTitle: {
      type: String,
      required: true
    },
    /** 表示する項目 */
    displayItemList: {
      type: Array as PropType<FridgeDetailsDisplaySettingsListItem[]>,
      required: true
    },
    /** クイック操作ボタンの設定項目 */
    displayQuickButtonItemList: {
      type: Array as PropType<FridgeDetailsDisplaySettingsListItem[]>,
      default: []
    },
    /** クイック操作ボタン以降に表示する設定 */
    displayAfterQuickButtonItemList: {
      type: Array as PropType<FridgeDetailsDisplaySettingsListItem[]>,
      default: []
    },
    isInitial: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const footerText = "に設定します。";
    const cancelText = "キャンセル";
    const sendText = "送信";
    const quickButtonTitle = "クイック操作ボタン";

    const cancelClicked = () => {
      context.emit("click-cancel", props.isInitial);
    };

    const sendClicked = () => {
      NativeClient.sendDebugLog("FridgeDetailsConfirmSettingsDialog sendClicked props.isInitial = " + props.isInitial);
      context.emit("click-send", props.isInitial);
    };

    return {
      quickButtonTitle,
      footerText,
      cancelText,
      sendText,
      cancelClicked,
      sendClicked
    };
  }
});
